/* eslint-disable lines-around-comment */
import React from 'react';
// @ts-expect-error
import UIEvents from '../../../../../service/UI/UIEvents';
import { createProfilePanelButtonEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
// @ts-ignore
import { AbstractDialogTab } from '../../../base/dialog';
import { translate } from '../../../base/i18n/functions';
import { Button } from '../../../base/ui/components/web';
import Input from '../../../base/ui/components/web/Input';
// @ts-ignore
import { openLogoutDialog } from '../../actions';
/**
 * React {@code Component} for modifying the local user's profile.
 *
 * @augments Component
 */
class ProfileTab extends AbstractDialogTab {
    /**
     * Initializes a new {@code ConnectedSettingsDialog} instance.
     *
     * @param {Props} props - The React {@code Component} props to initialize
     * the new {@code ConnectedSettingsDialog} instance with.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once for every instance.
        this._onAuthToggle = this._onAuthToggle.bind(this);
        this._onDisplayNameChange = this._onDisplayNameChange.bind(this);
        this._onEmailChange = this._onEmailChange.bind(this);
    }
    /**
     * Changes display name of the user.
     *
     * @param {string} value - The key event to handle.
     *
     * @returns {void}
     */
    _onDisplayNameChange(value) {
        super._onChange({ displayName: value });
    }
    /**
     * Changes email of the user.
     *
     * @param {string} value - The key event to handle.
     *
     * @returns {void}
     */
    _onEmailChange(value) {
        super._onChange({ email: value });
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { authEnabled, displayName, email, hideEmailInSettings, readOnlyName, t // @ts-ignore
         } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", { className: 'profile-edit' },
                React.createElement("div", { className: 'profile-edit-field' },
                    React.createElement(Input, { disabled: readOnlyName, id: 'setDisplayName', label: t('profile.setDisplayNameLabel'), name: 'name', onChange: this._onDisplayNameChange, placeholder: t('settings.name'), type: 'text', value: displayName })),
                !hideEmailInSettings && React.createElement("div", { className: 'profile-edit-field' },
                    React.createElement(Input, { id: 'setEmail', label: t('profile.setEmailLabel'), name: 'email', onChange: this._onEmailChange, placeholder: t('profile.setEmailInput'), type: 'text', value: email }))),
            authEnabled && this._renderAuth()));
    }
    /**
     * Shows the dialog for logging in or out of a server and closes this
     * dialog.
     *
     * @private
     * @returns {void}
     */
    _onAuthToggle() {
        // @ts-ignore
        if (this.props.authLogin) {
            sendAnalytics(createProfilePanelButtonEvent('logout.button'));
            APP.store.dispatch(openLogoutDialog(() => APP.UI.emitEvent(UIEvents.LOGOUT)));
        }
        else {
            sendAnalytics(createProfilePanelButtonEvent('login.button'));
            APP.UI.emitEvent(UIEvents.AUTH_CLICKED);
        }
    }
    /**
     * Returns a React Element for interacting with server-side authentication.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderAuth() {
        const { authLogin, t
        // @ts-ignore
         } = this.props;
        return (React.createElement("div", null,
            React.createElement("h2", { className: 'mock-atlaskit-label' }, t('toolbar.authenticate')),
            authLogin
                && React.createElement("div", { className: 'auth-name' }, t('settings.loggedIn', { name: authLogin })),
            React.createElement(Button, { accessibilityLabel: authLogin ? t('toolbar.logout') : t('toolbar.login'), id: 'login_button', label: authLogin ? t('toolbar.logout') : t('toolbar.login'), onClick: this._onAuthToggle })));
    }
}
ProfileTab.defaultProps = {
    displayName: '',
    email: ''
};
// @ts-ignore
export default translate(ProfileTab);
